import {
  PlatformsService
} from '@/common/api.service'
import {
  FETCH_PLATFORMS,
  FETCH_PLATFORM,
  APPLICATION_DELETE,
  PLATFORM_DELETE,
  PLATFORM_AUTHORIZE
} from './actions.type'
import {
  FETCH_START,
  FETCH_END,
  SET_PLATFORM
} from './mutations.type'

const state = {
  platforms: [],
  isLoading: true,
  platformsCount: 0
}

const getters = {
  platformsCount(state) {
    return state.platformsCount
  },
  platforms(state) {
    return state.platforms
  }
}

const actions = {
  [FETCH_PLATFORMS]({ commit }) {
    commit(FETCH_START)
    return PlatformsService.query()
      .then(({ data }) => {
        const collection = { platforms: data.data, platformsCount: data.data.length }
        commit(FETCH_END, collection)
      })
      .catch((error) => {
        throw new Error(error)
      })
  },
  [FETCH_PLATFORM](context, platformId) {
    return PlatformsService.get(platformId)
      .then(({ data }) => {
        context.commit(SET_PLATFORM, data)
        return data
      })
  },
  [PLATFORM_DELETE](context, slug) {
    return PlatformsService.destroy(slug)
  },
  [APPLICATION_DELETE](context, id) {
    return PlatformsService.destroyApplication(id)
  },
  [PLATFORM_AUTHORIZE](context, item) {
    context.commit(FETCH_START)
    if (item.payload) {
      return PlatformsService.authorize(item.slug, item.payload)
    }
    return PlatformsService.get(item.slug, item.code, item.shop)
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START](state) {
    state.isLoading = true
  },
  [FETCH_END](state, { platforms, platformsCount }) {
    // console.log(shippingsCount)
    state.platforms = platforms
    state.platformsCount = platformsCount
    state.isLoading = false
  },
  [SET_PLATFORM](state, platform) {
    state.platform = platform
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
